import { UPDATE_PROFILE } from '../../types';

const initialstate = {
    profileData: {}
};

export default (state: any = initialstate, action: any) => {
    switch (action.type) {
        case UPDATE_PROFILE:
            return {
                ...state,
                profileData: action?.payload
            }
        default:
            return state;
    }
};